// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { TeamProvider } from "./TeamContext";

// Pages
import HomePage from "./pages/HomePage";
import EquityCalculatorPage from "./pages/EquityCalculatorPage";
import ReportPage from "./pages/ReportPage";
import Layout from "./ui/Layout";

function App() {
    return (
        <TeamProvider>
            <Router>
                <Routes>
                    <Route path="/" element={<Layout />}>
                        <Route path="home" element={<HomePage />} />
                        <Route path="calculator" element={<EquityCalculatorPage />} />
                        <Route path="report" element={<ReportPage />} />
                        {/* Redirect the root "/" to /calculator */}
                        <Route index element={<Navigate to="/calculator" replace />} />
                    </Route>
                </Routes>
            </Router>
        </TeamProvider>
    );
}

export default App;
